import request from '@/utils/request'
import ApiUrls from "@/api/apiUrls";

export default{
    GetUserList:function (data) {
        return request({
            url:ApiUrls.GetUserList,
            method:'post',
            data
        })  
    },
   
    CustomerDelete:function (data) {
        return request({
            url:ApiUrls.CustomerDelete,
            method:'post',
            data
        })
    },
    CustomersRemove:function (data) {
        return request({
            url:ApiUrls.CustomersRemove,
            method:'post',
            data
        })
    },
    ResertPassword:function (data) {
        return request({
            url:ApiUrls.PasswordReset,
            method:'post',
            data
        })
    },
    UserUpdate:function (data) {
        return request({
            url:ApiUrls.UserUpdate,
            method:'post',
            data
        })
    },
    UserInsert:function (data) {
        return request({
            url:ApiUrls.UserInsert,
            method:'post',
            data
        })
    },
    UserDisable:function (data) {
        return request({
            url:ApiUrls.UserDisable,
            method:'post',
            data
        })
    },
    UserActive:function (data) {
        return request({
            url:ApiUrls.UserActive,
            method:'post',
            data
        })
    },

    CustomerAddUpdate:function (data) {
        return request({
            url:ApiUrls.CustomerAddUpdate,
            method:'post',
            data
        })  
    },
    UserListGet:function (data) {
        return request({
            url:ApiUrls.UserListGet,
            method:'post',
            data
        })
    },
    RoleUserBind:function (data) {
        return request({
            url:ApiUrls.RoleUserBind,
            method:'post',
            data
        })
    },
    RoleUserRemove:function (data) {
        return request({
            url:ApiUrls.RoleUserRemove,
            method:'post',
            data
        })
    },
    PasswordEdit:function (data) {
        return request({
            url:ApiUrls.PasswordEdit,
            method:'post',
            data
        })
    },
    
}